// TODO: right now it's exactly what diagnostics.js is doing. However, I don't think it's actually 100% right.
// We should register an onreadystatechange callback and see the actual response from the server (should be 200 OK).
export function uploadLogs(logs, remoteUlsEndpoint, async) {
    if (remoteUlsEndpoint === '')
        return;
    var request = new XMLHttpRequest();
    if (request.readyState === XMLHttpRequest.UNSENT || request.readyState === XMLHttpRequest.DONE) {
        request.open('POST', remoteUlsEndpoint, async);
        // Keep this a simple request by not adding any custom headers. This avoids the preflight OPTIONS request.
        // Only start sending custom headers if absolutely necessary for the server to handle to request.
        // CORS Simple Requests:https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Simple_requests
        request.send(logs);
    }
}
//# sourceMappingURL=bUlsUploader.js.map